import { defineAsyncComponent } from 'vue';

export default {
    // VALID
    FormFilters: defineAsyncComponent(() => import('@/componentsv2/FormFilters.vue')),
    Paginator: defineAsyncComponent(() => import('@/componentsv2/Paginator.vue')),
    SortCustom: defineAsyncComponent(() => import("@/componentsv2/SortCustom.vue")),
    FormSortPaginate: defineAsyncComponent(() => import("@/componentsv2/FormSortPaginate.vue")),
    // UTILS
    OctoloCardv2: defineAsyncComponent(() => import('@/componentsv2/Cardv2.vue')),
    OctoloButtonv2: defineAsyncComponent(() => import('@/componentsv2/Button.vue')),
    OctoloLabelv2: defineAsyncComponent(() => import('@/componentsv2/Label.vue')),
    OctoloLinkv2: defineAsyncComponent(() => import('@/componentsv2/Link.vue')),
    ValidCancelv2: defineAsyncComponent(() => import('@/componentsv2/ValidCancel.vue')),
    OctoloCardSeparator: defineAsyncComponent(() => import('@/componentsv2/Card/CardSeparator.vue')),
    DropDownMenu: defineAsyncComponent(() => import('@/componentsv2/DropDownMenu.vue')),
    Commands: defineAsyncComponent(() => import('@/componentsv2/Commands.vue')),
    TabManager: defineAsyncComponent(() => import('@/componentsv2/TabManager/')),
    Loader: defineAsyncComponent(() => import('@/componentsv2/Loader/')),
    ZoomTool: defineAsyncComponent(() => import('@/componentsv2/ZoomTool.vue')),
    ProgressBar:  defineAsyncComponent(() => import('@/componentsv2/ProgressBar.vue')),
    OctoloFormv2: defineAsyncComponent(() => import("@/componentsv2/Form")),
    OctoloInput: defineAsyncComponent(() => import("@/componentsv2/Form/Input/")),
    CreateOrUpdatev2: defineAsyncComponent(() => import("@/componentsv2/CreateOrUpdate.vue")),
    OctoloTitle: defineAsyncComponent(() => import('@/componentsv2/Title.vue')),
    OctoloMessagev2: defineAsyncComponent(() => import('@/componentsv2/Message.vue')),
    OctoloExports: defineAsyncComponent(() => import('@/componentsv2/Exports.vue')),
    OctoloSubscriber: defineAsyncComponent(() => import('@/componentsv2/Subscriber.vue')),
    Modalv2: defineAsyncComponent(() => import('@/componentsv2/ModalV2.vue')),
    HtmlEditor: defineAsyncComponent(() => import("@/componentsv2/HtmlEditor.vue")),
    ToolTip: defineAsyncComponent(() => import('@/componentsv2/ToolTip.vue')),
    CheckboxV2: defineAsyncComponent(() => import('@/componentsv2/Checkbox.vue')),
    // SERVICE
    CostTable: defineAsyncComponent(() => import('@/componentsv2/CostTable.vue')),

    // ITEMS
    // A mettre a jour
    Box: defineAsyncComponent(() => import("@/toremove/components/octolo/utils/Box.vue")),
    // A supprimer
    OctoloCard: defineAsyncComponent(() => import('@/componentsv2/Card')),
    OctoloForm: defineAsyncComponent(() => import("@/toremove/components/octolo/forms/Form.vue")),
    OctoloItem: defineAsyncComponent(() => import("@/toremove/components/octolo/items/Item.vue")),
    OctoloButton: defineAsyncComponent(() => import("@/toremove/components/octolo/button/Button.vue")),
    OctoloMessage: defineAsyncComponent(() => import("@/toremove/components/octolo/message/Message.vue")),
    ValidCancel: defineAsyncComponent(() => import("@/toremove/components/octolo/utils/ValidCancel.vue")),
    StepContainer: defineAsyncComponent(() => import("@/componentsv2/StepContainer.vue")),
}
